import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import PageLayout from '../components/layout/PageLayout';
import Button from '../components/ui/Button';
import Card from '../components/ui/Card';
import { HomeIcon, ArrowLeftIcon } from '@heroicons/react/24/outline';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <PageLayout>
      <div className="py-12 md:py-20 max-w-3xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center"
        >
          {/* 404 Number */}
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ type: "spring", duration: 0.8 }}
            className="mb-8"
          >
            <h1 className="font-display text-9xl md:text-[12rem] font-bold bg-gradient-to-br from-primary-600 to-primary-400 bg-clip-text text-transparent mb-4">
              404
            </h1>
          </motion.div>

          {/* Main Message Card */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
          >
            <Card padding="lg" className="mb-8">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                Page Not Found
              </h2>
              <p className="text-xl text-gray-600 mb-6 leading-relaxed">
                Sorry, the page you're looking for doesn't exist or has been moved.
              </p>
              
              {/* Helpful Links */}
              <Card padding="md" className="bg-primary-50 border-2 border-primary-200 mb-6">
                <p className="text-gray-700 font-medium mb-2">Looking for something?</p>
                <p className="text-gray-600 text-sm">
                  Try going back to the home page to start your video legacy journey.
                </p>
              </Card>

              {/* Action Buttons */}
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Button
                  variant="primary"
                  size="lg"
                  onClick={() => navigate('/')}
                  className="min-w-[200px]"
                >
                  <span className="flex items-center gap-2">
                    <HomeIcon className="h-5 w-5" />
                    <span>Go to Home</span>
                  </span>
                </Button>
                
                <Button
                  variant="outline"
                  size="lg"
                  onClick={() => navigate(-1)}
                  className="min-w-[200px]"
                >
                  <span className="flex items-center gap-2">
                    <ArrowLeftIcon className="h-5 w-5" />
                    <span>Go Back</span>
                  </span>
                </Button>
              </div>
            </Card>
          </motion.div>

          {/* Footer */}
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4 }}
            className="text-gray-500 text-sm mt-8"
          >
            This document is the property of The Sizzleisland Company Limited © 2025
          </motion.p>
        </motion.div>
      </div>
    </PageLayout>
  );
};

export default NotFound;

